var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('SettleStat',{attrs:{"mid":_vm.mid}}),_c('ListTerminals',{attrs:{"mid":_vm.mid}}),_c('TerminalDetails',{attrs:{"mid":_vm.mid}}),_c('div',{staticClass:"link-box"},[_c('Auth',{attrs:{"mid":_vm.mid}}),_c('VoidCharge',{attrs:{"mid":_vm.mid}}),_c('Refund',{attrs:{"mid":_vm.mid}}),_c('Inquire',{attrs:{"mid":_vm.mid}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }